import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { Auth0Provider } from '@auth0/auth0-react';
import { store } from './redux/store';
import App from './app';
import { FULL_REDIRECT_PATH } from './shared/constants';
import { determineAuth0DomainSettings } from './shared/utils/login-utils';

document.body.style.margin = 0;

const { domain, clientId } = determineAuth0DomainSettings();
const rootElement = document.getElementById('root');
ReactDOM.render(
  <CookiesProvider>
    <Provider store={store}>
      <BrowserRouter>
        <Auth0Provider
          domain={domain}
          clientId={clientId}
          authorizationParams={{
            redirect_uri: FULL_REDIRECT_PATH,
            scope: 'openid profile email',
          }}
          cacheLocation="localstorage"
        >
          <App />
        </Auth0Provider>
      </BrowserRouter>
    </Provider>
  </CookiesProvider>,
  rootElement,
);
